import React from "react";
import { useAuth } from "../context/AuthContext";
import { NumberInput } from "./ui/number-input";
import {
  CLIENT_PRICING_TIER_OPTIONS,
  getPricingTierLabel,
} from "../utils/pricingTemplates";

function PricingFactorsSection({ formData, dispatch, FormInput, FormSelect }) {
  const { isAdmin } = useAuth();

  return (
    <fieldset className="pricing-factors">
      <legend>Pricing Factors</legend>
      <div className="pricing-factors__ownership" role="note">
        <strong>Admin-controlled factors</strong>
        <span>
          The client tier selects an approved pricing template for this
          estimate. The percentages below come from company settings and only an
          admin can override them for this estimate. Overrides here never change
          the company-wide defaults.
        </span>
      </div>
      <FormSelect
        label="Client Pricing Tier"
        field="client_pricing_tier"
        value={
          formData.client_pricing_tier ||
          formData.default_client_pricing_tier ||
          "retail"
        }
        options={CLIENT_PRICING_TIER_OPTIONS}
        dispatch={dispatch}
        className="pricing-factors__select"
        tooltip={`Switches the estimate to the ${getPricingTierLabel(
          formData.client_pricing_tier ||
            formData.default_client_pricing_tier ||
            "retail",
        )} pricing template. Manual estimate overrides are preserved.`}
      />
      {/* The "Labor Rate Type" selector was retired 2026-08-18 (owner
			    ratified): the burden rate IS the labor cost per employee-hour the
			    engine bills hours at, and the Island Millwork rate is a client
			    charge-out reference. Choosing it here fed a charge-out rate back
			    through overhead + profit + commission and double-billed labor.
			    Shop labor rate now lives in admin Pricing Settings; the per-job
			    override below is the only per-estimate labor lever. */}
      <FormInput
        label="Overhead Ratio (%)"
        field="overhead_ratio"
        value={formData.overhead_ratio}
        dispatch={dispatch}
        type="number"
        step="0.5"
        disabled={!isAdmin}
      />
      <FormInput
        label="Profit Margin (%)"
        field="profit_margin"
        value={formData.profit_margin}
        dispatch={dispatch}
        type="number"
        step="0.5"
        disabled={!isAdmin}
      />
      <FormInput
        label="Material Sales Tax (%)"
        field="material_sales_tax_rate"
        value={formData.material_sales_tax_rate}
        dispatch={dispatch}
        type="number"
        step="0.5"
        disabled={!isAdmin}
      />
      <FormInput
        label="Sales Commission (%)"
        field="commission_rate"
        value={formData.commission_rate}
        dispatch={dispatch}
        type="number"
        step="0.5"
        disabled={!isAdmin}
      />
      <FormInput
        label="Shop Commission Profit Sharing (%)"
        field="shop_commission_profit_sharing_rate"
        value={formData.shop_commission_profit_sharing_rate}
        dispatch={dispatch}
        type="number"
        step="0.5"
        disabled={!isAdmin}
      />
      {isAdmin ? (
        <div className="form-group">
          <label htmlFor="job_labor_burden_override" className="form-label">
            Job burden rate override ($/hr)
          </label>
          <NumberInput
            id="job_labor_burden_override"
            align="left"
            step="0.01"
            min={0}
            value={formData.job_labor_burden_override ?? ""}
            onValueChange={(value) =>
              dispatch({
                type: "UPDATE_FIELD",
                field: "job_labor_burden_override",
                value,
              })
            }
            aria-label="Job burden rate override ($/hr)"
          />
          <p
            style={{
              fontSize: "0.85rem",
              color: "#666",
              marginTop: "0.35rem",
              fontStyle: "italic",
            }}
          >
            Admin only — prices THIS estimate at a different burden rate (e.g.
            replaying a $34-era sheet). Blank = the ratified global rate.
          </p>
        </div>
      ) : null}
    </fieldset>
  );
}

export default PricingFactorsSection;
